import axios from "../utils/request";

export default {
    productList(data,merchanId) {
        return axios.post(`/product/list/${merchanId}`,{...data})
    },

    productTags(merchanId) {
        return axios.get(`/merchantProductTags/get/${merchanId}`)
    }
}